import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
export const Carousel = ({ images, enabled }) => {
    const swiperRef = useRef();
    return (React.createElement("div", { className: "images-container" },
        React.createElement(Swiper, { modules: [Pagination], pagination: {
                clickable: true,
                enabled,
            }, loop: true, autoHeight: true, ref: swiperRef }, images.map((image) => (React.createElement(SwiperSlide, { key: image },
            React.createElement("img", { src: image, alt: image }))))),
        images.length > 1 ? (React.createElement(React.Fragment, null,
            React.createElement("button", { type: "button", className: "swiper-button-prev", onClick: () => {
                    swiperRef.current.swiper.slidePrev();
                } },
                React.createElement("i", { className: "icon-chevron-left" })),
            React.createElement("button", { type: "button", className: "swiper-button-next", onClick: () => {
                    swiperRef.current.swiper.slideNext();
                } },
                React.createElement("i", { className: "icon-chevron-right" })))) : null));
};
